import React, { useState,useEffect } from "react";
import { Card, Row, Col, Spin, Form, Input, Button,Modal,Tabs,Select,Checkbox  } from "antd";
import * as util from '../Helpers/Util';
import history from "../../history";
import queryString, { parse } from "query-string";
import idariMahalleSorgula from "../../services/idariMahalleSorgula";
import getAdaParselList from "../../services/adaParselList";
import basvuruOlustur from "../../services/basvuruOlustur";
import iskanParentBasvuruOlustur from "../../services/iskanParentBasvuruOlustur";
import FormItem from "antd/lib/form/FormItem";


const { Option } = Select;
const parsed = queryString.parse(history.location.search);
const yapiDenetimKontrolu = parsed['yapiDenetimKontrolu']?.toLowerCase?.() === 'true';

const formLayout = {
  labelCol: {
    span: 2,
  },
  wrapperCol: {
    span: 8,
  },
};

const yapiDenetimVarMi =
[
  {
    "objectid": 1,
    "adi": "Evet"
  },
  {
    "objectid": 0,
    "adi": "Hayır"
  }
];

const CreateIskanBasvuruWithAdaParselForm = () => {

    const [form] = Form.useForm();
    const [spining, setSpining] = useState(false);
    const [mahalles, setMahalles] = useState([]);
    const [adaParsel, setAdaParsel] = useState([]);

    const load = async() => {
        await idariMahalleSorgula().then(res => { setMahalles(res.data.result) });
      }
    
      const getAdaParsel = async(mahId) => {    
        setSpining(true);
    
        await setAdaParsel([]);
        await getAdaParselList( { "IdariMahalleId" : mahId }).then(resp => setAdaParsel(resp.data.result));
    
        setSpining(false);
      }
    
      useEffect(() => {
        load();
      },[]);

      
    const onFinish = async(values) => {
        setSpining(true);
    
        let parentBasvuruFilter= {
          BelgeTuruId :  11,
          BelgeGrubuId : 11,
          GeoMahalleId : values['Mahalle'],
          ParselId : values['AdaParsel'],
          YapiDenetimVarMi : yapiDenetimKontrolu ? values['YapiDenetimVarMi'] : 0
        };
    
        await iskanParentBasvuruOlustur(parentBasvuruFilter).then(async resp => {
          if(resp.data.success){
            let basvuruFilter= {
              altSurecTipiId :  parseInt(parsed['altSurecTipiId']),
              parentObjectId : resp.data.result.objectid,
            };
        
            await basvuruOlustur(basvuruFilter).then(basvuruResp => {
              if(basvuruResp.data.success){
                var result = basvuruResp.data.result;
                window.location.replace(window.location.origin + '/belnet/genericclass/GenelBFormu.aspx?&KODU=' + result.BasvuruId +'&BFORM='+ result.BasvuruFormUrl + '&belge_turu_id='+result.BelgeTuruId +'&alt_surec_tipi_id='+ result.AltSurecTipiId +'&parent_objectid='+result.ParentBasvuruId + '&nomaster=true');
              }else{
                util.errorMessage(basvuruResp.data.message);
              }
            }).catch(ex => {
              util.errorMessage(String(ex.message))
            });
          }else{
            util.errorMessage(resp.data.message);
          }
        }).catch(ex => {
          util.errorMessage(String(ex.message))
        })
    
        setSpining(false);
      }
    

    return (

        <Spin tip={"Veriler yükleniyor/sorgulanıyor..."} spinning={spining}>
            <Card bodyStyle={{ padding: "10", fontWeight: "bold" }}>
            Ada/Parsel Başvurusu 
            </Card>

            <Form form={form} {...formLayout} onFinish={onFinish} name="TusForm">
            <Form.Item
            label="İdari Mahalle"
            name="Mahalle"
            labelAlign="left"
            rules={[{ required: true, message: "Lüften Mahalle bilgisini giriniz" }]}
            >
                <Select
                    showSearch
                    allowClear
                    onChange={getAdaParsel}               
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Mahalle"
                    
                >
                    {mahalles && mahalles.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
                </Select>
            </Form.Item>
            <Form.Item
            label="Ada/Parsel"
            name="AdaParsel"
            rules={[{ required: true, message: "Lüften Ada/Parsel bilgisini giriniz" }]}
            labelAlign="left"
            >
                <Select
                    showSearch
                    allowClear
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Ada/Parsel"
                    
                >
                    {adaParsel && adaParsel.map(bt => <Option  key={bt.objectId} value={bt.objectId}>{bt.adaParsel}</Option>)}
                </Select>
            </Form.Item>

            {yapiDenetimKontrolu && 
            <Form.Item
            label="Yapı denetim var mı?"
            name="YapiDenetimVarMi"
            rules={[{ required: true, message: "Lüften yapı denetim var mı bilgisini giriniz" }]}
            labelAlign="left"
            >
                <Select
                    showSearch
                    allowClear
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Evet/Hayır"
                >
                    {yapiDenetimVarMi && yapiDenetimVarMi.map(bt => <Option  key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
                </Select>
            </Form.Item>
            }
            <Row>
            <Col span={6} style={{ textAlign: "right" }}>
                <Button type="primary" htmlType="submit">
                Kaydet
                </Button>
            </Col>
            </Row>
        </Form>
      </Spin>
      );
}

export default CreateIskanBasvuruWithAdaParselForm;